import { fromJS } from 'immutable';
import {
  SET_SEARCH_CLAIMS,
  RESET_SEARCH_CLAIMS_STORE,
  SET_LOSS_DATE,
  SET_SELECTED_CLAIM,
  SET_FOUND_CLAIMS,
} from 'containers/IdentificationPage/constants';
import { RESET_STORE } from 'containers/LoginPage/constants';

export interface SearchClaimsAction {
  type: string;
  searchClaims: any;
  lossDate: Date | null;
  selectedClaim: number | null;
  foundClaims: any;
}

const initialState: any = fromJS({
  searchClaims: {},
  lossDate: null,
  selectedClaim: null,
  foundClaims: {},
});

const searchClaimsReducer = (
  state = initialState,
  action: SearchClaimsAction,
) => {
  switch (action.type) {
    case SET_SEARCH_CLAIMS:
      return state.set('searchClaims', fromJS(action.searchClaims.data));
    case SET_FOUND_CLAIMS:
      return state.set('foundClaims', fromJS(action.foundClaims.data));
    case SET_LOSS_DATE:
      return state.set('lossDate', action.lossDate);
    case SET_SELECTED_CLAIM:
      return state.set('selectedClaim', action.selectedClaim);
    case RESET_STORE:
      return initialState;
    case RESET_SEARCH_CLAIMS_STORE:
      return initialState;
    default:
      return state;
  }
};

export default searchClaimsReducer;
